// import fieldOfCareData from '@/data/fields.json'
import allExtModData from '@/data/extensionsModules.json'
import allAppsData from '@/data/applications.json'
import allLayoutsData from '@/data/layouts.json'
import allAccessoriesData from '@/data/accessories.json'

import mixins from '@/mixins.js'

import { getDefaultState } from './state'

const PREV_STEP = state => {
  const prevState = state.activeStep
  state.steps[prevState].complete = true
  state.activeStep = Math.max(0, state.activeStep - 1)
}

const NEXT_STEP = state => {
  const prevState = state.activeStep
  // we dont really need "complete" feature of this do we since moving back should still show
  // which is active, not which is "complete"
  state.steps[prevState].complete = true
  state.activeStep = Math.min(state.steps.length, state.activeStep + 1)
}

const CHANGE_STEP = (state, indx) => {
  const prevState = state.activeStep
  state.steps[prevState].complete = true
  if (indx === 'last') {
    state.activeStep = state.steps.length - 1
  } else {
    const st = parseInt(indx)
    if (st && st >= 0 && st < state.steps.length) {
      state.activeStep = indx
    } else {
      state.activeStep = 0
    }
  }
}

/**
 * If you open shared url, complete previous steps automatically
 */
const COMPLETE_STEPS_ON_SHARE = state => {
  for (let i = 0; i < state.steps.length - 1; i++) {
    state.steps[i].complete = true
  }
}

/**
 * If ABI + TBI are selected delete TBI and add TBP
 */
const ADJUST_ABI_TBI = state => {
  state.selected.extensionsModules = mixins.removeItemsFromArray(state.selected.extensionsModules, ['TBISYSCS4'])
  state.selected.extensionsModules.push('TBPSYSCS4')
  state.disabled.extensionsModules = mixins.removeItemsFromArray(state.disabled.extensionsModules, ['TBPSYSCS4', 'BPSYSCS4', 'BPSYS'])
  state.disabled.extensionsModules.push('TBISYSCS4')
  state.snackbars.selectionDisabledText = 'MESI just made your configuration better by selecting only the necessary hardware! Get the same results with less equipment!'
  state.snackbars.selectionDisabled = true
}

/**
 * If you go back to selection and TBP is selected, delete TBP and add TBI to have ABI + TBI
 */
const READJUST_ABI_TBI = state => {
  const tbiExtDisabled = ['TBPSYSCS4', 'BPSYSCS4', 'BPSYS']
  state.selected.extensionsModules = mixins.removeItemsFromArray(state.selected.extensionsModules, ['TBPSYSCS4'])
  state.selected.extensionsModules.push('TBISYSCS4')
  state.disabled.extensionsModules = mixins.removeItemsFromArray(state.disabled.extensionsModules, ['TBISYSCS4'])
  state.disabled.extensionsModules.push(...tbiExtDisabled)
}

const UPDATE_SELECTED_FIELD = (state, systemId) => {
  state.selectedField = systemId
}

const TOGGLE_EXTENSION_MODULE = (state, payload) => {
  const moduleID = payload.id
  const addOnly = payload.addOnly || false
  const selectedExtMods = state.selected.extensionsModules.slice()
  const index = selectedExtMods.indexOf(moduleID)
  const add = (index < 0)

  const extMod = state.extensionsModulesByID[moduleID]
  if (typeof extMod === 'undefined') {
    return
  }

  if (add) {
    // console.log('ADD: ' + moduleID)
    state.selected.extensionsModules.push(moduleID)
  } else {
    // console.log('Remove: ' + moduleID)
    if (addOnly) {
      return
    }
    state.selected.extensionsModules.splice(index, 1)
  }

  // Unselect any package because the config and price changed
  state.selectedPackage = null

  // Disable light package
  if (state.selected.extensionsModules.length > 2) {
    state.litePackageDisabled = true
  } else {
    state.litePackageDisabled = false
  }
}

const SELECT_PACKAGE = (state, payload) => {
  if (payload[0]) {
    state.selectedPackage = payload[0]
    state.selectedPackageData = payload[1].find(packageData => packageData.HubspotValue === payload[0])
  } else {
    state.selectedPackage = null
    state.selectedPackageData = {}
  }
}

const SYNC_DATA = state => {
  // const p1 = performance.now()

  let includedApps = []
  let allowedApps = []

  let includedAccessories = []
  let allowedAccessories = []

  state.fullPriceMTAB = 0
  state.priceFull = 0
  state.price = 0
  state.priceGreenPackage = 0
  state.pricePremiumPackage = 0

  let disabledExtMods = []

  for (const mID of state.selected.extensionsModules) {
    const meObj = state.extensionsModulesByID[mID]

    if (typeof meObj === 'undefined') {
      return
    }

    disabledExtMods = mixins.concatAndRemoveDuplicates(disabledExtMods, meObj.extensionsModules.disabled)
  }

  state.disabled.extensionsModules = disabledExtMods

  // Those that are disabled should not be on selected list now
  const removed = mixins.arrayIntersection(state.selected.extensionsModules, state.disabled.extensionsModules)
  state.selected.extensionsModules = mixins.removeItemsFromArray(state.selected.extensionsModules, state.disabled.extensionsModules)
  if (removed.length > 0) {
    state.dialogs.disabledItemsBySelectingAnother = removed
    state.snackbars.selectionDisabled = true
  }

  for (const mID of state.selected.extensionsModules) {
    const meObj = state.extensionsModulesByID[mID]

    if (typeof meObj === 'undefined') {
      return
    }

    /**
     * FULL PRICE LOGIC --> not displayed in subscription version
     * Calculate the smallest mTablet price from selected modules and add it to priceFull
     * after you loop currntly selected modules --> So the one with te smallest mTablet price
     * will be the selected "system", the others will be "extentions" --> The difference
     * between sys and ext price will be added with this priceItemMTAB, so when we add
     * prices of selected modules, we add the prices of "extensions" --> meObj.fullPriceExt
     */
    const priceItemMTAB = meObj.fullPriceSys - meObj.fullPriceExt

    if (priceItemMTAB < state.fullPriceMTAB || state.fullPriceMTAB === 0) {
      state.fullPriceMTAB = priceItemMTAB
    }
    /**
     * UPDATE PRICES (we reset to 0 above then recalculate each time - its easier this way since its
     * just addition - no subtraction. And no need to track prices.
     * Drawback: SLOWER ofcourse since this whole thing runs each time anything is added/removed.
     * Final prices are calculated in a watcher inside PriceDisplay.vue
     */
    const priceFull = typeof meObj.fullPriceExt !== 'undefined' ? parseFloat(meObj.fullPriceExt) : 0
    const price = typeof meObj.subsPriceEur !== 'undefined' ? parseFloat(meObj.subsPriceEur) : 0
    const priceGreen = typeof meObj.subsPriceGreenEur !== 'undefined' ? parseFloat(meObj.subsPriceGreenEur) : 0
    const pricePremium = typeof meObj.subsPricePremiumEur !== 'undefined' ? parseFloat(meObj.subsPricePremiumEur) : 0
    state.priceFull += priceFull
    state.price += price
    state.priceGreenPackage += priceGreen
    state.pricePremiumPackage += pricePremium

    // console.log('Price for ' + mID + ': ' + price)

    /**
     * Update preselected and allowed apps/accessories
     */

    includedApps = mixins.concatAndRemoveDuplicates(includedApps, meObj.applications.included)
    includedAccessories = mixins.concatAndRemoveDuplicates(includedAccessories, meObj.accessories.included)

    allowedApps = mixins.concatAndRemoveDuplicates(allowedApps, meObj.applications.allowed)
    allowedAccessories = mixins.concatAndRemoveDuplicates(allowedAccessories, meObj.accessories.allowed)
  }

  /**
   * Add mTablet full price for current selection
   */
  state.priceFull += state.fullPriceMTAB

  /**
   * Update preselected, selected & allowed APPS
   */
  const keepSelectedApps = mixins.arrayIntersection(state.selected.applications.slice(), allowedApps)
  state.preselected.applications = includedApps
  state.selected.applications = mixins.concatAndRemoveDuplicates(keepSelectedApps, includedApps)
  state.allowed.applications = allowedApps

  /**
   * Update Layouts
   * Enables/disabled TROLLEYECG based on ECGSYSCS4 extension/module
   */
  if (state.selected.extensionsModules.includes('ECGSYSCS4')) {
    state.disabled.layouts = mixins.removeItemsFromArray(state.disabled.layouts, ['TROLLEYECG'])
  } else {
    if (!state.disabled.layouts.includes('TROLLEYECG')) {
      state.disabled.layouts.push('TROLLEYECG')

      // if this was previously selected, select normal TROLLEY instead
      // TODO: alert the user?
      if (state.selected.layout === 'TROLLEYECG') {
        state.selected.layout = 'TROLLEY'
      }
    }
  }

  /**
   * Update preselected, selected & allowed ACCESSORIES
   */
  const keepSelectedAccessories = mixins.arrayIntersection(state.selected.accessories.slice(), allowedAccessories)
  state.preselected.accessories = includedAccessories
  state.selected.accessories = mixins.concatAndRemoveDuplicates(keepSelectedAccessories, includedAccessories)
  state.allowed.accessories = allowedAccessories

  /**
   * UPDATE PRICE based on APPS
   */
  for (const id of state.selected.applications) {
    if (!state.preselected.applications.includes(id)) {
      const item = state.applicationsByID[id]
      const priceFull = typeof item.fullPrice !== 'undefined' ? parseFloat(item.fullPrice) : 0
      const price = typeof item.subsPriceEur !== 'undefined' ? parseFloat(item.subsPriceEur) : 0
      const priceGreen = typeof item.subsPriceGreenEur !== 'undefined' ? parseFloat(item.subsPriceGreenEur) : 0
      const pricePremium = typeof item.subsPricePremiumEur !== 'undefined' ? parseFloat(item.subsPricePremiumEur) : 0
      state.priceFull += priceFull
      state.price += price
      state.priceGreenPackage += priceGreen
      state.pricePremiumPackage += pricePremium
    }
  }

  /**
   * UPDATE PRICE based on ACCESSORIES
   */
  for (const id of state.selected.accessories) {
    if (!state.preselected.accessories.includes(id)) {
      const item = state.accessoriesByID[id]
      const priceFull = typeof item.fullPrice !== 'undefined' ? parseFloat(item.fullPrice) : 0
      const price = typeof item.subsPriceEur !== 'undefined' ? parseFloat(item.subsPriceEur) : 0
      const priceGreen = typeof item.subsPriceGreenEur !== 'undefined' ? parseFloat(item.subsPriceGreenEur) : 0
      const pricePremium = typeof item.subsPricePremiumEur !== 'undefined' ? parseFloat(item.subsPricePremiumEur) : 0
      state.priceFull += priceFull
      state.price += price
      state.priceGreenPackage += priceGreen
      state.pricePremiumPackage += pricePremium
    }
  }

  // Add mTablet default price for final prices
  if (state.selected.extensionsModules.length > 0) {
    state.pricesAfterMtab.price = state.price + state.defaultPriceMTAB
    state.pricesAfterMtab.priceGreenPackage = state.priceGreenPackage + state.defaultPriceMTAB
    state.pricesAfterMtab.pricePremiumPackage = state.pricePremiumPackage + state.defaultPriceMTAB

    // show the GREEN price as 15% discount
    state.pricesAfterMtab.greenDiscountFrom = mixins.oldPriceByDiscount(state.pricesAfterMtab.priceGreenPackage, 15)
  }

  // const p2 = performance.now()
  // console.log(p2 - p1 + ' ms')
}

const TOGGLE_APPLICATION = (state, appID, onlyAdd = false) => {
  const selectedApps = state.selected.applications.slice()
  const index = selectedApps.indexOf(appID)
  const add = (index < 0)

  const appObj = state.applicationsByID[appID]
  if (typeof appObj === 'undefined') {
    return
  }

  if (add) {
    state.selected.applications.push(appID)
    // console.log('ADDING app: ', appID)
    if (appObj.noticeText) {
      state.snackbars.generalSnackbarText = appObj.noticeText
      state.snackbars.general = true
    }
  } else {
    if (onlyAdd) {
      return
    }

    state.selected.applications.splice(index, 1)
  }
}

const SET_LAYOUT = (state, layoutID) => {
  const meObj = state.layoutsByID[layoutID]

  state.selected.layout = layoutID
  state.selected.accessories = mixins.removeItemsFromArray(state.selected.accessories, state.preselected.accessoriesActive)
  state.preselected.accessoriesActive = meObj.accessories.included
  state.selected.accessories = mixins.concatAndRemoveDuplicates(state.selected.accessories, meObj.accessories.included)
}

const TOGGLE_ACCESSORY = (state, accID, onlyAdd = false) => {
  const selected = state.selected.accessories.slice()
  const index = selected.indexOf(accID)
  const add = (index < 0)

  const acc = state.accessoriesByID[accID]
  if (typeof acc === 'undefined') {
    return
  }

  if (add) {
    state.selected.accessories.push(accID)
    // console.log('ADDING accessory: ', accID)
  } else {
    if (onlyAdd) {
      return
    }

    state.selected.accessories.splice(index, 1)
  }
}

const RESET_STATE = state => {
  Object.assign(state, getDefaultState())
}

const SET_CONFIG_CODE = (state, code) => {
  state.configCode = code
}

const SET_CONFIG_URL = (state, url) => {
  state.configURL = url
}

const SET_VISUAL_LINE_HEIGHT = (state, newHeight) => {
  // console.log('SET_VISUAL_LINE_HEIGHT() to ' + newHeight)
  state.visualLineHeight = newHeight
}

const SET_APP_HEIGHT = (state, newHeight) => {
  // console.warn('SET_APP_HEIGHT: ' + newHeight)
  state.appHeight = newHeight
}

/**
 * Needs to be called when changing steps since a step can have a different navigation
 * (last step for example - and also when changing from 4 back to any we have to re-adjust)
 */
const SET_NAV_HEIGHT = (state, newHeight) => {
  state.navigationHeight = newHeight
}

const SHOW_TERMS_CONDITIONS = (state, bool = true) => {
  state.dialogs.termsConditions = bool
}

const SHOW_FAQ = (state, bool = true) => {
  state.dialogs.faq = bool
}

const SHOW_SEND_INQUIRY_DIALOG = state => {
  state.dialogs.sendInquiry = true
}

const SHOW_DIALOG_THANK_YOU = state => {
  state.dialogs.thankYou = true
}

const SHOW_GENERIC_DIALOG = (state, obj) => {
  if (typeof obj.text === 'undefined') {
    return
  }
  state.dialogs.genericDialogContent = obj.text
  state.dialogs.genericDialogLoading = typeof obj.loading !== 'undefined' ? obj.loading : false
  state.dialogs.generic = true
}

const SHOW_SHARE_DIALOG = state => {
  state.dialogs.share = true
}

const CLOSE_SHARE_DIALOG = state => {
  state.dialogs.share = false
}

const CLOSE_GENERIC_DIALOG = state => {
  state.dialogs.generic = false
}

const CLOSE_SELECTION_DISABLED_DIALOG = state => {
  state.dialogs.selectionDisabled = false
}

const CLOSE_ALL_DIALOGS = state => {
  state.genericDialogContent = ''
  state.dialogs.generic = false
  state.dialogs.selectedPackage = false
  state.dialogs.sendInquiry = false
  state.dialogs.thankYou = false
}

const REFRESH_VISUAL_BLOCK_KEY = state => {
  // console.warn('REFRESH_VISUAL_BLOCK_KEY')
  state.visualBlockKey = (Date.now() + Math.random())
}

const SET_VISUAL_BLOCK_NEGATIVE_MARGIN_TOP = (state, marginTopN) => {
  state.visualBlockNegativeMargin = marginTopN
  // console.log('NEW MARGIN TOP Negative: ', marginTopN)
}

const SET_STEP_VISUAL_HEIGHT = (state, obj) => {
  if (typeof obj.stepIndx === 'undefined' || typeof obj.height === 'undefined') {
    return
  }
  // console.log('set step ', obj.stepIndx, ' in vuex visual height to ', obj.height)
  state.steps[obj.stepIndx].visualStepHeight = obj.height
}

const SET_SELECTED = (state, selectedObject) => {
  // console.log(' - - - - - update SELECTED: ', selectedObject)
  Object.assign(state.selected, selectedObject)
}

const SET_PRESELECTED = (state, preselectedObject) => {
  // console.log(' - - - - - update PRE-SELECTED: ', preselectedObject)
  Object.assign(state.preselected, preselectedObject)
}

/**
 * So we can access object data by ID easily across the app
 */
const GENERATE_BY_ID_OBJECTS = state => {
  for (const obj of allExtModData) {
    state.extensionsModulesByID[obj.id] = obj
  }

  for (const obj of allAppsData) {
    state.applicationsByID[obj.id] = obj
  }

  for (const obj of allLayoutsData) {
    state.layoutsByID[obj.id] = obj
  }

  for (const obj of allAccessoriesData) {
    state.accessoriesByID[obj.id] = obj
  }
}

const SET_DEFAULT_MTAB_PRICE = state => {
  if (state.extensionsModulesByID.MTABSYSW) {
    state.defaultPriceMTAB = state.extensionsModulesByID.MTABSYSW.subsPriceEur
  }
}

const HIDE_SELECTION_DISABLED_SNACKBAR = state => {
  state.snackbars.selectionDisabled = false
  state.snackbars.selectionDisabledText = 'MESI just made your configuration better by deselecting unnecessary hardware! Get the same results using our Smart App.'
}

const HIDE_GENERAL_SNACKBAR = state => {
  state.snackbars.general = false
}

const SET_VISUAL_BLOCK_VISIBLE_MOBILE = (state, visible) => {
  state.visualBlockVisibleMobile = visible
}

export default {
  PREV_STEP,
  NEXT_STEP,
  CHANGE_STEP,
  COMPLETE_STEPS_ON_SHARE,
  ADJUST_ABI_TBI,
  READJUST_ABI_TBI,
  SET_CONFIG_CODE,
  SET_CONFIG_URL,
  UPDATE_SELECTED_FIELD,
  TOGGLE_EXTENSION_MODULE,
  SELECT_PACKAGE,
  SYNC_DATA,
  TOGGLE_APPLICATION,
  SET_LAYOUT,
  TOGGLE_ACCESSORY,
  RESET_STATE,
  SET_VISUAL_LINE_HEIGHT,
  SET_APP_HEIGHT,
  SET_NAV_HEIGHT,
  SHOW_TERMS_CONDITIONS,
  SHOW_FAQ,
  SHOW_SEND_INQUIRY_DIALOG,
  SHOW_DIALOG_THANK_YOU,
  SHOW_GENERIC_DIALOG,
  CLOSE_GENERIC_DIALOG,
  SHOW_SHARE_DIALOG,
  CLOSE_SHARE_DIALOG,
  CLOSE_SELECTION_DISABLED_DIALOG,
  CLOSE_ALL_DIALOGS,
  REFRESH_VISUAL_BLOCK_KEY,
  SET_VISUAL_BLOCK_NEGATIVE_MARGIN_TOP,
  SET_STEP_VISUAL_HEIGHT,
  SET_SELECTED,
  SET_PRESELECTED,
  GENERATE_BY_ID_OBJECTS,
  SET_DEFAULT_MTAB_PRICE,
  HIDE_SELECTION_DISABLED_SNACKBAR,
  HIDE_GENERAL_SNACKBAR,
  SET_VISUAL_BLOCK_VISIBLE_MOBILE
}
